import L from "leaflet";


export function removeCSSClass(ele, cls) {
  const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
  ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
  ele.classList.add(cls);
}

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

export function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;

      }

      return config;
    },
    err => Promise.reject(err)
  );
}


export function removeStorage(key) {
  try {
    localStorage.setItem(key, "");
    localStorage.setItem(key + "_expiresIn", "");
  } catch (e) {
    console.log(
      "removeStorage: Error removing key [" +
      key +
      "] from localStorage: " +
      JSON.stringify(e)
    );
    return false;
  }
  return true;
}

/*  getStorage: retrieves a key from localStorage previously set with setStorage().
    params:
        key <string> : localStorage key
    returns:
        <string> : value of localStorage key
        null : in case of expired key or failure
 */
export function getStorage(key) {
  const now = Date.now(); //epoch time, lets deal only with integer
  // set expiration for storage
  let expiresIn = localStorage.getItem(key + "_expiresIn");
  if (expiresIn === undefined || expiresIn === null) {
    expiresIn = 0;
  }

  expiresIn = Math.abs(expiresIn);
  if (expiresIn < now) {
    // Expired
    removeStorage(key);
    return null;
  } else {
    try {
      const value = localStorage.getItem(key);
      return value;
    } catch (e) {
      console.log(
        "getStorage: Error reading key [" +
        key +
        "] from localStorage: " +
        JSON.stringify(e)
      );
      return null;
    }
  }
}
/*  setStorage: writes a key into localStorage setting a expire time
    params:
        key <string>     : localStorage key
        value <string>   : localStorage value
        expires <number> : number of seconds from now to expire the key
    returns:
        <boolean> : telling if operation succeeded
 */
export function setStorage(key, value, expires) {
  if (expires === undefined || expires === null) {
    expires = 24 * 60 * 60; // default: seconds for 1 day
  }

  const now = Date.now(); //millisecs since epoch time, lets deal only with integer
  const schedule = now + expires * 1000;
  try {
    localStorage.setItem(key, value);
    localStorage.setItem(key + "_expiresIn", schedule);
  } catch (e) {
    console.log(
      "setStorage: Error setting key [" +
      key +
      "] in localStorage: " +
      JSON.stringify(e)
    );
    return false;
  }
  return true;
}
export const NosignalpointerIcon = new L.Icon({
  iconUrl: toAbsoluteUrl("/media/icons/Mapicons/parked_bike2.svg"),
  iconRetinaUrl: toAbsoluteUrl("/media/icons/Mapicons/parked_bike2.svg"),
  popupAnchor: [0, 0],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(50, 50),
  iconAnchor: [25, 25],
});
export const NosignalBikeIcon = new L.Icon({
  iconUrl: toAbsoluteUrl("/media/icons/Mapicons/parked_bike2.svg"),
  iconRetinaUrl: toAbsoluteUrl("/media/icons/Mapicons/parked_bike2.svg"),
  popupAnchor: [0, 0],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(50, 50),
  iconAnchor: [25, 25],
});
export const downloadByUrl = (url, onAsyncResponse, onComplete) => {
  console.log(url);

  const isLocalhost =
    window.location.hostname === "localhost";
  //  || window.location.hostname === "127.0.0.1";

  if (isLocalhost) {
    // On localhost, cross-origin restrictions ignore the "download" attribute on direct URLs.
    // We fetch as a blob and trigger a local blob download to force the correct extension.
    fetch(url, { credentials: "include" })
      .then(function (response) {
        if (response.status === 204) {
          if (typeof onComplete === "function") onComplete(204);
          return;
        }
        if (!response.ok && response.status !== 200) {
          if (typeof onComplete === "function") onComplete(response.status);
          return;
        }

        const contentType = response.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
          return response.json().then(function (jsonData) {
            const message = jsonData.message || "Report is being processed.";
            if (typeof onAsyncResponse === "function") {
              onAsyncResponse(message);
            } else {
              window.alert(message);
            }
            if (typeof onComplete === "function") onComplete(200);
          });
        } else {
          return response.blob().then(function (blob) {
            let extension = ".pdf";
            const lowerUrl = url.toLowerCase();
            if (lowerUrl.includes("exportid=2") || lowerUrl.includes("excel")) {
              extension = ".xlsx";
            } else if (lowerUrl.includes("exportid=1") || lowerUrl.includes("pdf")) {
              extension = ".pdf";
            } else if (lowerUrl.includes("exportid=3") || lowerUrl.includes("word")) {
              extension = ".doc";
            }

            const forcedBlob = new Blob([blob], { type: "application/octet-stream" });
            const blobUrl = window.URL.createObjectURL(forcedBlob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", `Report_${Date.now()}${extension}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);

            if (typeof onComplete === "function") {
              onComplete(200);
            }
          });
        }
      })
      .catch(function (error) {
        console.error("Localhost download error:", error);
        if (typeof onComplete === "function") onComplete(500);
      });
  } else {
    // In production, fetch first to check if the response is an ASYNC JSON status or a file blob
    fetch(url, { credentials: "include" })
      .then(function (response) {
        if (response.status === 204) {
          if (typeof onComplete === "function") onComplete(204);
          return;
        }
        if (!response.ok && response.status !== 200) {
          if (typeof onComplete === "function") onComplete(response.status);
          return;
        }

        const contentType = response.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
          return response.json().then(function (jsonData) {
            const message = jsonData.message || "Report is being processed.";
            if (typeof onAsyncResponse === "function") {
              onAsyncResponse(message);
            } else {
              window.alert(message);
            }
            if (typeof onComplete === "function") onComplete(200);
          });
        } else {
          // It's the file, download it as a blob using the single fetch
          return response.blob().then(function (blob) {
            let extension = ".pdf";
            const lowerUrl = url.toLowerCase();
            if (lowerUrl.includes("exportid=2") || lowerUrl.includes("excel")) {
              extension = ".xlsx";
            } else if (lowerUrl.includes("exportid=1") || lowerUrl.includes("pdf")) {
              extension = ".pdf";
            } else if (lowerUrl.includes("exportid=3") || lowerUrl.includes("word")) {
              extension = ".doc";
            }

            // Try to determine the filename from content-disposition if present
            const disposition = response.headers.get("content-disposition");
            let filename = `Report_${Date.now()}${extension}`;
            if (disposition && disposition.indexOf("attachment") !== -1) {
              const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "").trim();
              }
            }

            const forcedBlob = new Blob([blob], { type: "application/octet-stream" });
            const blobUrl = window.URL.createObjectURL(forcedBlob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);

            if (typeof onComplete === "function") {
              onComplete(200);
            }
          });
        }
      })
      .catch(function (error) {
        console.error("Production download error:", error);
        if (typeof onComplete === "function") onComplete(500);
      });
  }
};


/** Data download */
export const getDataDownloadYears = (startYear = 2020) => {
  const currentYear = new Date().getFullYear();
  return Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );
};